module.exports = __webpack_public_path__ + "img/recomEmpty.2fad744e.png";